import { CDN_URL_1 } from "@/config";
export const CDN_URL = 'https:' + CDN_URL_1 + '/box_active'
export class ActivityInfo {
  constructor () {
    this.icon = ''
    this.id = ''
    this.title = ''
    this.startTime = ''
    this.endTime = ''
  }
}

export const FEEDTYPE_MAP = {
  SUCCESS: 'SUCCESS', // 成功
  INSUFFICIENT_GIFT: 'INSUFFICIENT_GIFT', // 礼包码不足
  NO_ROLE: 'NO_ROLE', // 没有角色
  FIRST_CHARGE: 'FIRST_CHARGE', // 首次充值
  CONDITION_NOT_SATISFY: 'CONDITION_NOT_SATISFY', // 条件不满足
}

// 任务类型
export const ConditionTypeEnum = [
  { value: 1, label: '游戏内创角' },
  { value: 2, label: '角色等级' },
  { value: 3, label: '首次充值' },
  { value: 4, label: '当日付费' },
  { value: 5, label: '累计付费' },
]

export const FrequenceEnum = [
  { value: 0, label: '限领一次' },
  { value: 1, label: '每日刷新' },
]
